import { ReportPage, ReportTable } from '@/components';
import type { FundOwnerForLocalGovernmentTableProps } from '@/features/mold/utils/pdf/pdf-components-props';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const TableFundOwnerForLocalGovernment: FC<
  FundOwnerForLocalGovernmentTableProps
> = ({ fiscalYear, header, rowData, footer, paperSize, projectName }) => {
  const { t } = useTranslation();
  return (
    <ReportPage
      title={{
        weight: 'regular',
        variant: 'footnote',
        text: t(
          'report-fund-owner-for-local-government-individual-table-title',
          {
            year: fiscalYear,
            projectName,
          },
        ),
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      caption={{
        unit: 'thousand',
      }}
    >
      <ReportTable
        header={header}
        data={rowData}
        footer={footer}
        tableWidth="100%"
      />
    </ReportPage>
  );
};
